module.exports = "https://img.zhijierongxing.com/saas/img/fo_icon.60082df3.png";